import React, { useEffect, useState } from "react";
import * as Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
// import graphQuery from "../../../../../assets/images/graphQuery.svg";
import ColoumnsHeader from "../../generic/ColoumnsHeader";
import { DBStatistics } from "../../../../../Containers/vendor/DashBoard/DBCosntants";
import { convertRS, handleTickInterval, weeklyDataValue } from "../../utlits";
import {
  addDays,
  CompareDate,
  getDiffBtnDates,
} from "../../../../utils/dateCalculater";
import NoDataFound from "../../generic/NoDataFound";

export interface ILSStackColProps {
  uniqueOrdData: Array<DBStatistics>;
  uniqueTradeData: any;
  handleDownloadBtn: () => void;
}

const LSStackCol: React.FC<ILSStackColProps> = (props) => {
  const [disableMenu, setDisableMenu] = useState<boolean>(false);

  const [orderTradeData, setOrderTradeData] = useState<any>({
    category: [],
    orders: [],
    trades: [],
    tickInterval: 0,
  });

  const [sortedOrdsPrDay, setSortedOrdsPrDay] = useState<Array<DBStatistics>>(
    []
  );
  const [sortedTrdsPrDay, setSortedTrdsPrDay] = useState<Array<DBStatistics>>(
    []
  );

  const setUpChart = async () => {
    if (
      sortedTrdsPrDay.length > weeklyDataValue ||
      sortedOrdsPrDay.length > weeklyDataValue
    ) {
      let firstDate =
        sortedOrdsPrDay && sortedTrdsPrDay
          ? CompareDate(
              sortedOrdsPrDay[0].key,
              sortedTrdsPrDay[0].key,
              "smallerDate"
            )
          : "";

      let lastDate =
        sortedOrdsPrDay && sortedTrdsPrDay
          ? CompareDate(
              sortedOrdsPrDay[sortedOrdsPrDay.length - 1].key,
              sortedTrdsPrDay[sortedTrdsPrDay.length - 1].key,
              "biggerDate"
            )
          : "";

      let totalWeeks = await getDiffBtnDates(firstDate, lastDate);
      if (totalWeeks % 1 !== 0) {
        totalWeeks = Math.floor(totalWeeks) + 1;
      }
      // let getTickInterval = await handleTickInterval(totalWeeks);
      let getOrderData = [...sortedOrdsPrDay];
      let getTradeData = [...sortedTrdsPrDay];

      let category = [];
      let orderData = [];
      let tradeData = [];

      let dateOne = firstDate;
      for (let i = 0; i <= totalWeeks; i++) {
        let seventhDay = await addDays(dateOne, 6);

        // eslint-disable-next-line no-loop-func
        let customOrderData = getOrderData.filter((date: any) => {
          return (
            date.key >= moment(dateOne).format("YYYY-MM-DD") &&
            date.key <= moment(seventhDay).format("YYYY-MM-DD")
          );
        });

        // eslint-disable-next-line no-loop-func
        let customTradeData = getTradeData.filter((date: any) => {
          return (
            date.key >= moment(dateOne).format("YYYY-MM-DD") &&
            date.key <= moment(seventhDay).format("YYYY-MM-DD")
          );
        });

        if (customOrderData.length > 0) {
          let sumOfOrder = 0;
          for (let i = 0; i < customOrderData.length; i++) {
            sumOfOrder += parseInt(customOrderData[i].val);
          }

          orderData.push(sumOfOrder);
        } else {
          if (dateOne <= lastDate) {
            orderData.push(0);
          }
        }

        if (customTradeData.length > 0) {
          let sumOfTrade = 0;
          for (let i = 0; i < customTradeData.length; i++) {
            sumOfTrade += parseInt(customTradeData[i].val);
          }
          tradeData.push(sumOfTrade);
        } else {
          if (dateOne <= lastDate) {
            tradeData.push(0);
          }
        }

        if (dateOne <= lastDate) {
          if (lastDate < seventhDay) {
            category.push(
              `${moment(dateOne).format("YYYY-MM-DD")} to ${moment(
                lastDate
              ).format("YYYY-MM-DD")}`
            );
          } else {
            category.push(
              `${moment(dateOne).format("YYYY-MM-DD")} to ${moment(
                seventhDay
              ).format("YYYY-MM-DD")}`
            );
          }
        }

        dateOne = await addDays(seventhDay, 1);
      }
      let getTickInterval = await handleTickInterval(category.length);

      if (category.length > 0 || orderData.length > 0 || tradeData.length > 0) {
        setOrderTradeData({
          category: [...category],
          orders: [...orderData],
          trades: [...tradeData],
          tickInterval: getTickInterval,
        });
      }
    } else {
      let category: any = [];
      let orderData: any = [];
      let tradeData: any = [];

      //  adding date in catagry of both sortedOrdsPrDay and sortedTrdsPrDay
      sortedOrdsPrDay.forEach((ord: any) => {
        category.push(ord.key);
      });
      sortedTrdsPrDay.forEach((trd: any) => {
        if (!category.includes(trd.key)) {
          category.push(trd.key);
        }
      });

      category.sort();

      // checking if data available for catagry's date then add data otherwise add 0
      if (category.length > 0) {
        category.forEach((cat: any) => {
          if (sortedTrdsPrDay.some((trd: any) => trd.key === cat)) {
            let getTrade = sortedTrdsPrDay.filter((sortTrd: any) => {
              return sortTrd.key === cat;
            });
            tradeData.push(parseInt(getTrade[0].val));
          } else {
            tradeData.push(0);
          }

          if (sortedOrdsPrDay.some((ord: any) => ord.key === cat)) {
            let getOrder = sortedOrdsPrDay.filter((sortOrd: any) => {
              return sortOrd.key === cat;
            });
            orderData.push(parseInt(getOrder[0].val));
          } else {
            orderData.push(0);
          }
        });
      }
      let getTickInterval = await handleTickInterval(category.length);

      if (category.length > 0 || orderData.length > 0 || tradeData.length > 0) {
        setOrderTradeData({
          category: [...category],
          orders: [...orderData],
          trades: [...tradeData],
          tickInterval: getTickInterval,
        });
      }
    }
  };

  useEffect(() => {
    if (props.uniqueOrdData.length > 0 || props.uniqueTradeData.length > 0) {
      setDisableMenu(false);
      setSortedOrdsPrDay(props.uniqueOrdData);
      setSortedTrdsPrDay(props.uniqueTradeData);
    } else {
      setDisableMenu(true);
      setSortedOrdsPrDay([]);
      setSortedTrdsPrDay([]);
      setOrderTradeData({
        category: [],
        orders: [],
        trades: [],
      });
    }
  }, [props.uniqueOrdData, props.uniqueTradeData]);

  useEffect(() => {
    if (
      (sortedOrdsPrDay && sortedOrdsPrDay.length > 0) ||
      (sortedTrdsPrDay && sortedTrdsPrDay.length > 0)
    ) {
      setUpChart();
    }
  }, [sortedOrdsPrDay, sortedTrdsPrDay]);

  const options = {
    chart: {
      type: "column",
      height: "300px",
    },
    title: "",
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: orderTradeData.category,
      crosshair: true,
      tickInterval: orderTradeData.tickInterval,
      tickPixelInterval: 100,
      labels: {
        formatter: function (this: any): any {
          if (this.value.includes("to")) {
            let splitVal = this.value.split("to");
            return `${moment(splitVal[0]).format("DD MMM 'YY")} - ${moment(
              splitVal[1]
            ).format("DD MMM 'YY")}`;
          } else {
            return moment(this.value).format("DD MMM 'YY"); // clean, unformatted number for year
          } // clean, unformatted number for year
        },
      },
    },
    legend: {
      symbolRadius: 2,
      itemMarginTop: 0,
      itemMarginBottom: -20,
    },
    colors: ["#1c9ad6", "#f7943e"],
    yAxis: {
      title: "",
      margin: "0",
      padding: "0",
      labels: {
        formatter: function (this: any): any {
          let val = convertRS(this.value, 0);
          return val;
        },
      },
      reversedStacks: false,
    },

    tooltip: {
      formatter: function (this: any): any {
        let tooltipVal = "";
        if (this.points[0]?.x.includes("to")) {
          let splitVal = this.points[0].x.split("to");
          tooltipVal = `${moment(splitVal[0]).format("DD MMM 'YY")} - ${moment(
            splitVal[1]
          ).format("DD MMM 'YY")}`;
        } else {
          tooltipVal = moment(this.points[0].x).format("DD MMM 'YY");
        }
        return `<b><p className="gray">${tooltipVal}</p></b>
              </br><b><span style="color:${
                this.points[0].color
              }">Client Orders</span> : ${
          this.points[0].y
        }</b></br><b><span  style="color:${
          this.points[1].color
        }">Client Trades</span> : ${this.points[1] ? this.points[1].y : 0}</b>`;
      },
      shared: true,
      backgroundColor: "white",
      borderColor: "white",
      borderRadius: 10,
      borderWidth: 0,
      padding: 10,
    },
    plotOptions: {
      column: {
        stacking: "normal",
        dataLabels: {
          enabled: false,
        },
      },
    },
    series: [
      {
        name: "Client Orders",
        data: orderTradeData.orders,
      },
      {
        name: "Client Trades",
        data: orderTradeData.trades,
      },
    ],
  };

  return (
    <>
      <ColoumnsHeader
        title={"Unqiue Clients Ordered / Trades"}
        isDownload={true}
        disableMenu={disableMenu}
        handleDownloadBtn={props.handleDownloadBtn}
      />
      {disableMenu ? (
        <NoDataFound />
      ) : (
        <HighchartsReact highcharts={Highcharts} options={options} />
      )}
    </>
  );
};

export default LSStackCol;
